/**
 * string format operation
 */
export const strFormat = (inputStr, type) => {
  try {
    let all = type.split("|");
    if (all.includes("length")) {
      inputStr = inputStr.trim();
      if (inputStr) {
        return inputStr.length;
      }
      return 0;
    }
    if (all.includes("trim")) {
      inputStr = inputStr.trim();
    }
    if (all.includes("number")) {
      inputStr = inputStr.replace(/[^0-9]/g, "");
    }
    if (all.includes("text")) {
      inputStr = inputStr.replace(/\d/g, ""); // This regex replaces all digits (numbers) with an empty string.
    }
    if (all.includes("float") && inputStr) {
      inputStr = inputStr.replace(/[^0-9.]/g, "");
      if (inputStr) {
        const nparts = inputStr.split(".");
        if (nparts.length > 2) {
          inputStr = nparts[0] + "." + nparts.slice(1).join("");
        }
        const parts = inputStr ? inputStr.split(".") : [];
        if (parts.length !== 0) {
          if (parts.length === 2 && parts[1].length > 2) {
            inputStr = parts[0] + "." + parts[1].substring(0, 2);
          }
        }
      }
    }

    for (const formatter of all) {
      const [command, ...args] = formatter.split(":");
      switch (command) {
        case "max":
          const maxLength = parseInt(args[0]);
          if (inputStr.length > maxLength) {
            inputStr = inputStr.slice(0, maxLength);
          }
          break;
        case "max-value":
          const maxValue = parseInt(args[0]);
          if (inputStr) {
            if (maxValue < inputStr) {
              inputStr = maxValue;
            }
          }
          break;
        case "min-value":
          const minValue = parseFloat(args[0]);
          if (inputStr) {
            if (minValue > inputStr) {
              inputStr = "";
            }
          }
          break;
        default:
          break;
      }
    }
    inputStr = inputStr ? inputStr.replace(/^\s+/, "") : "";
  } catch (e) {}
  return inputStr;
};
